module.exports = __webpack_public_path__ + "static/media/logoBlueCCMB.e6d675c7.png";